import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { CalendarClock, RefreshCw } from "lucide-react";

export function KitchenIcalImport({ kitchenId }) {
  const [kitchen, setKitchen] = useState(null);
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const { data } = await api.get(`/kitchens/${kitchenId}`);
    setKitchen(data);
    setUrl(data.external_ical_url || "");
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [kitchenId]);

  const importIcal = async () => {
    if (!url.trim()) { toast.error("Paste a public iCal URL"); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/kitchens/${kitchenId}/ical-import`, { ical_url: url.trim() });
      toast.success(`Imported ${data.events_imported} busy blocks`);
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Import failed");
    } finally { setBusy(false); }
  };

  const refresh = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/kitchens/${kitchenId}/ical-refresh`);
      toast.success(`Refreshed — ${data.events_imported} busy blocks`);
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Refresh failed");
    } finally { setBusy(false); }
  };

  if (!kitchen) return null;
  const busyCount = (kitchen.external_busy || []).length;

  return (
    <div className="border hairline p-4" data-testid={`ical-import-${kitchenId}`}>
      <div className="flex items-start gap-3">
        <CalendarClock size={18} className="text-[#FF3B30] mt-1" />
        <div className="flex-1">
          <div className="tick-label">{kitchen.name} · external calendar</div>
          <p className="text-neutral-500 text-xs mt-1">
            Paste a public Google Calendar iCal URL (Settings → Integrate → Public URL). Busy blocks auto-block bookings.
          </p>
          <div className="mt-3 flex items-stretch gap-2 flex-wrap">
            <input
              data-testid={`ical-url-input-${kitchenId}`}
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://calendar.google.com/calendar/ical/…/basic.ics"
              className="flex-1 min-w-[240px] border hairline px-3 py-2 font-mono text-xs focus:outline-none focus:border-[#FF3B30]"
            />
            <button data-testid={`ical-import-btn-${kitchenId}`} onClick={importIcal} disabled={busy} className="btn-signal disabled:opacity-50">
              {busy ? "..." : "Import"}
            </button>
            {kitchen.external_ical_url && (
              <button data-testid={`ical-refresh-btn-${kitchenId}`} onClick={refresh} disabled={busy} className="btn-outline inline-flex items-center gap-2">
                <RefreshCw size={12} /> Refresh
              </button>
            )}
          </div>
          {busyCount > 0 && (
            <div className="tick-label text-[#FF3B30] mt-3">{busyCount} busy block(s) blocking bookings</div>
          )}
        </div>
      </div>
    </div>
  );
}
